import {Tooltip, Typography} from "@material-tailwind/react";
import React from "react";
import {color, variant} from "@material-tailwind/react/types/components/typography";

interface Props {
    text?: number | string;
    variant?: variant;
    color?: color;
    className?: string;
    style?: any;
    tooltip?: string;
}

export function CustomTypography({text, className, color, variant, style, tooltip}: Props) {
    const displayText = text !== undefined ? text : '';

    return (
        <>
            {(tooltip && tooltip !== '') ?
                <Tooltip className={"bg-primary"} content={tooltip}>
                    <Typography
                        placeholder='typography'
                        variant={variant}
                        color={color}
                        className={className}
                        style={style ? style : {}}
                    >
                        {displayText}
                    </Typography>
                </Tooltip> :
                <Typography
                    placeholder='typography'
                    variant={variant}
                    color={color}
                    className={className}
                    style={style ? style : {}}
                >
                    {displayText}
                </Typography>
            }
        </>
    )
}
